<div class="full-height-flex">
  <div class='step-sub-heading-with-actions'>
    <div class='step-content-header'>@if (titleIcon) {
      <mat-icon class='title'>{{titleIcon}}</mat-icon>
    }{{node.details.label}}</div>
  </div>
  <div class="remaining-space-flex-content-wrapper">
    <div class="remaining-space-flex-content">
      <div class="step-content-card item-details full-height" [ngClass]='boxShadowClass'>
        <p>
          <adm4-detail-message
            [node]='node'
            [outputType]='outputType'
            [pattern]='pattern'
            [projectKey]='projectKey'>
          </adm4-detail-message>
        </p>
        <p>
          <strong>Command</strong>
        </p>
        <p>{{node.details.command}}</p>
        <p>
          <strong>Deployment phase</strong>
        </p>
        <p>It is scheduled for the <strong>{{node.details.phase}}</strong> phase of the deployment.</p>
        @if (shouldDisplayConditions) {
          <p>
            <strong>Conditions</strong>
          </p>
          <p>
            This command will only be executed if at least one of the following conditions is met:
          </p>
          <ul>
            @for (file of conditionFiles; track file) {
              <li>
                <span>Change in file </span>
                <span class='link-button' (click)='navigateToArtifact(file.fileId)'>
                  {{file.path | nameFromPath}}
                </span>
              </li>
            }
            @for (trigger of conditionFailureTriggers; track trigger) {
              <li>
                <span>Failed </span><span [class.link-button]='canNavigateToTrigger' (click)='navigateToTrigger(trigger.triggerId)'>{{trigger.label}}</span>
              </li>
            }
            @for (trigger of conditionSuccessTriggers; track trigger) {
              <li>
                <span>Success </span><span [class.link-button]='canNavigateToTrigger' (click)="navigateToTrigger(trigger.triggerId)">{{trigger.label}}</span>
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </div>
</div>